/** @type {Map<number, number[]>} */
const courseIdsByUserGroupId = new Map();

export function getCachedUserGroupCourseIds(userGroupId) {
    return courseIdsByUserGroupId.get(userGroupId);
}

export function setCachedUserGroupCourseIds(userGroupId, courseIds) {
    courseIdsByUserGroupId.set(userGroupId, courseIds);
}

export function clearUserGroupCourseIdsCache() {
    courseIdsByUserGroupId.clear();
}
